import { z } from 'my-zod'

// https://www.iso.org/iso-4217-currency-codes.html
export const currencyEnum = z.enum(['USD', 'CreditV1']).setEnumLabels({
  USD: 'Dollars',
  CreditV1: 'CreditV1'
})

export type CurrencyType = z.infer<typeof currencyEnum>

export const CurrencyTypeOptions = Object.values(currencyEnum.Enum)

export const CurrencyTypes = currencyEnum.Enum

export const CurrencySymbols = {
  USD: '$',
  CreditV1: 'C'
} as const

export const CurrencyLabels = {
  USD: 'Dollars',
  CreditV1: 'CreditV1'
} as const
